import { Utils } from 'cc-common';

export class WFInvoiceHistoryParametersDto {
    communityId: number;
    payeeCode: string;
    invoiceNumber: string;

    workflowId: number;

    getQueryString(): string {
        let url = `?communityId=${this.communityId}&payeeCode=${this.payeeCode}&invoiceNumber=${this.invoiceNumber}`;

        if (Utils.notNullOrEmpty(this.workflowId)) {
            url += `&workflowId=${this.workflowId}`;
        }

        return url;
    }
}
